export default "__VITE_ASSET__joUjFGlz__"